import { B2BInquiryPropertiesTypes } from "@website/widget/login/components/b2b-inquiry/types";
import { AuthB2BRequestOtpService } from "@website/widget/login/services/auth-b2b-request-otp";
import {
  isPhoneNumberPartiallyValid,
  isPhoneNumberValid
} from "@website/widget/login/utils";
import { ChangeEvent, useCallback, useState } from "react";

export const useB2BInquiry = (properties: B2BInquiryPropertiesTypes) => {
  const { setStep, setUserData, userData } = properties;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [contractId, setContractId] = useState<string>("");

  const onChangePhoneNumber = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      if (isPhoneNumberPartiallyValid(value)) {
        setPhoneNumber(value);
      }
    },
    []
  );

  const onChangeContractId = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setContractId(value);
    },
    []
  );

  const onSubmitPhoneNumber = useCallback(
    async (_event: React.FormEvent<HTMLFormElement>) => {
      _event.preventDefault();
      if (isPhoneNumberValid(phoneNumber) && contractId) {
        setIsLoading(true);
        setError("");
        AuthB2BRequestOtpService({ phoneNumber })
          .then((data) => {
            setUserData({ ...userData, ...data, phoneNumber, contractId });
            setStep("otp");
          })
          .catch((error) => {
            setError(
              error?.response?.data?.message ||
                "خطایی رخ داده، دوباره تلاش کنید."
            );
          })
          .finally(() => setIsLoading(false));
      } else {
        setError("اطلاعات وارد شده صحیح نمیباشد.");
      }
    },
    [contractId, phoneNumber, setStep, setUserData, userData]
  );

  return {
    error,
    isLoading,
    phoneNumber,
    contractId,
    onChangePhoneNumber,
    onSubmitPhoneNumber,
    onChangeContractId
  };
};
